// frontend/src/components/Listing.jsx
import React, { useMemo } from 'react';
import PropertyCard from './PropertyCard';

const keyOf = (p) =>
  String(p?.objectID ?? p?.imovelId ?? p?.id ?? p?.refCodigo ?? '');

const Listing = ({ imoveis = [], onDelete = () => {} }) => {
  // Cinto de segurança: dedupe por id
  const list = useMemo(() => {
    const seen = new Set();
    return (Array.isArray(imoveis) ? imoveis : [])
      .filter(Boolean)
      .filter((p) => {
        const k = keyOf(p);
        if (!k) return true;
        if (seen.has(k)) return false;
        seen.add(k);
        return true;
      });
  }, [imoveis]);

  return (
    <section className="py-8">
      {list.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((imovel) => (
            <PropertyCard
              key={keyOf(imovel)}
              property={imovel} // ✅ prop correta
              onDelete={onDelete}
            />
          ))}
        </div>
      ) : (
        <p className="text-center text-gray-500" aria-live="polite">
          Nenhum imóvel encontrado.
        </p>
      )}
    </section>
  );
};

export default Listing;
